/**
 * Project Padma page — reuse homepage 25+1 pad graphic animation
 */
(function () {
  'use strict';

  var graphic = document.querySelector('[data-padma-graphic]');
  if (!graphic) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    graphic.classList.add('is-static');
    return;
  }

  var played = false;
  var armed = false;

  function armPlayback() {
    armed = true;
  }

  function playGraphic() {
    if (played) return;
    played = true;
    graphic.classList.add('is-playing');
    if (observer) observer.disconnect();
  }

  var viewHeight = window.innerHeight || document.documentElement.clientHeight;
  if (graphic.getBoundingClientRect().top > viewHeight * 0.85) {
    armPlayback();
  }

  window.addEventListener(
    'scroll',
    function onScroll() {
      armPlayback();
      window.removeEventListener('scroll', onScroll);
    },
    { passive: true }
  );

  var observer = null;

  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!armed || played || !entry.isIntersecting) return;
          if (entry.intersectionRatio < 0.2) return;
          playGraphic();
        });
      },
      { threshold: [0, 0.2, 0.35], rootMargin: '0px 0px -8% 0px' }
    );

    observer.observe(graphic);
  } else {
    armPlayback();
    playGraphic();
  }
})();
